import { observer } from 'mobx-react';
import { useAuth } from 'contexts/AuthContext';

const Home = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 flex flex-col items-center justify-center px-4">
      <div className="md:w-96 md:h-48 w-72 h-36 bg-logo bg-contain bg-no-repeat bg-center" />
      <div className="text-center max-w-2xl">
        <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 dark:text-white mb-6">
          Stream Your Events Like a Pro
        </h1>

        <p className="text-lg sm:text-xl text-gray-700 dark:text-gray-300 mb-4">
          No more restreaming from a Twitch web feed!
        </p>

        <p className="text-md sm:text-lg text-gray-600 dark:text-gray-400 mb-6">
          With our easy-to-use cloud-based solution, you can host high quality streaming events with
          ease — on demand and at an affordable price.
        </p>
        <a
          href={user ? '/dashboard' : `${process.env.NEXT_PUBLIC_DOMAIN}/accounts/login/`}
          className="inline-block px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-lg font-medium transition-colors mb-10"
        >
          {user ? 'Dashboard' : 'Login'}
        </a>
        <footer className="text-sm text-gray-500 dark:text-gray-500">
          &copy; 2020 - {new Date().getFullYear()} NoReset + Online Event Services
        </footer>
      </div>
    </div>
  );
};

export default observer(Home);
